const ComponentsLookup = {
  "local-partnership-page": "LocalPartnershipPage834593b5645e40069586387f5d2aba0e",
  "default-footer": "DefaultFooterEedb1e115f82436fB7d25aeb50a648d0",
  "default-header-top": "DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a",
  "secondary-page": "SecondaryPage2cfaf39d021c4756A02f2103f1c0338c",
  "secondary-marketing-header": "SecondaryMarketingHeader6b8a032f72b04707B52897cd51577a49",
  "secondary-marketing-hero": "SecondaryMarketingHero1aae8dab7a374d5bA61e95c17249843d",
  "about-us-page": "AboutUsPage12bd26b2E7e743d3A6f11d0661bd7b1e",
  "public-events-page": "PublicEventsPageD7f6752128ca4010A12113ca3c6da302",
  "join-us-page": "JoinUsPageD4c2730172d04144A4d933d4523cc5d8",
  "application-pages": "ApplicationPages68b863e0Ef19409cBdbfD049601391c7",
  "public-contact-page": "PublicContactPage7ba043e3517c475f930dE261b126e2d6",
  "public-faq-page": "PublicFaqPageE56e468c71e9457390519c528382b472",
  "home-page": "HomePageE1ce4a26A10145c69e87360c34d03f4c"
}

export default ComponentsLookup;